import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { apiFetchPredesTransactionsRelease, apiFetchPredesTransactionsBulkRelease } from '../../api/PredesTransactionsReleaseAPI';
import { PREDES_TRANSACTIONS_RELEASE_REQUEST, PREDES_TRANSACTIONS_BULK_RELEASE_REQUEST } from '../actions/types/PredesTransactionsReleaseActionsTypes';
import {
  postPredesTransactionsReleaseSuccessActionCreator,
  postPredesTransactionsReleaseFailureActionCreator,
  postPredesTransactionsBulkReleaseSuccessActionCreator,
  postPredesTransactionsBulkReleaseFailureActionCreator,
} from '../actions/PredesTransactionsReleaseActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doPredesTransactionsReleaseWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchPredesTransactionsRelease, action.payload);
    yield put(postPredesTransactionsReleaseSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.predes.transactions.release.success'),
    }));
  } catch (error) {
    yield put(postPredesTransactionsReleaseFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doPredesTransactionsBulkReleaseWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchPredesTransactionsBulkRelease, action.payload);
    yield put(postPredesTransactionsBulkReleaseSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.predes.transactions.bulkrelease.success'),
    }));
  } catch (error) {
    yield put(postPredesTransactionsBulkReleaseFailureActionCreator(error));
  }
}

function* doPredesTransactionsReleaseWatcher() {
  yield takeLatest(PREDES_TRANSACTIONS_RELEASE_REQUEST, doPredesTransactionsReleaseWorker);
  yield takeLatest(PREDES_TRANSACTIONS_BULK_RELEASE_REQUEST, doPredesTransactionsBulkReleaseWorker);
}

export default doPredesTransactionsReleaseWatcher;

export {
  doPredesTransactionsReleaseWorker,
  doPredesTransactionsBulkReleaseWorker,
};
